import { FC } from "react";
import Table from "../../../common/Table";
import { getAuth } from "../../../services/AuthService";
import { ICategoryGroup } from "../../../helpers/interfaces/ranking";
import { CategoryMatch } from "../../../helpers/interfaces/category";
import { categoryMatchesColumns, categoryMatchesMobileColumns } from "../../../config/Tables/category";

interface ICategoryMatchesTable {
    groupLabel: string,
    group: ICategoryGroup | undefined,
    day: number,
    groupMatches: CategoryMatch[],
}

const CategoryMatchesTable: FC<ICategoryMatchesTable> = (
    { groupLabel, group, day, groupMatches }
) => {
    const auth = getAuth();

    return group ? <div className="rank_groups_table fs-6" key={groupLabel}>
        <div className="rank_groups_table fs-6">
            <h3 className="text-center mt-3 group-title display-6 display-lg-4">{
                groupMatches?.length ? groupMatches[0].data : new Date().toLocaleDateString()
            }</h3>
            <div className='rank_groups_table'>
                <Table
                    id={`tab_rank_groups_${group.id}_days_${day}_table_${group.id}`}
                    columns={auth ? [...categoryMatchesColumns] : [...categoryMatchesColumns.slice(0, -1)]}
                    columnsMobile={auth ? [...categoryMatchesMobileColumns] : [...categoryMatchesMobileColumns.slice(0, -1)]}
                    data={groupMatches}
                    emptyDataText="Nessuna partita odierna presente"
                />
            </div>
        </div>
        <div id="tab_partite_odierne_caption" className='d-flex flex-wrap fs-7 ms-2'>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle rinviata" aria-hidden="true" /> = Rinviata
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle in-corso" aria-hidden="true" /> = In corso
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle sospesa" aria-hidden="true" /> = Sospesa
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle terminata" aria-hidden="true" /> = Terminata
            </div>
            <div className='mb-1 me-2 display-6 fs-6'>
                <i className="fa fa-circle-o da-giocare" aria-hidden="true" /> = Da giocare
            </div>
        </div>
    </div> : <></>
}

export default CategoryMatchesTable;